'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onDownloadClick: (platform: 'ios' | 'android') => void;
}

const CTASection = ({ onDownloadClick }: CTASectionProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <section className="py-20 px-4 lg:px-8 bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Ready to Start Trading Smarter?
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join 50,000+ traders making profit with AI-driven signals. Download now and get your first 7 days of premium free.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button className="flex items-center justify-center space-x-3 px-8 py-4 bg-foreground text-background rounded-xl hover:scale-105 transition-all duration-200 shadow-lg">
              <Icon name="DevicePhoneMobileIcon" size={24} />
              <div className="text-left">
                <div className="text-xs opacity-80">Download on the</div>
                <div className="text-lg font-heading font-semibold">App Store</div>
              </div>
            </button>
            <button className="flex items-center justify-center space-x-3 px-8 py-4 bg-foreground text-background rounded-xl hover:scale-105 transition-all duration-200 shadow-lg">
              <Icon name="DevicePhoneMobileIcon" size={24} />
              <div className="text-left">
                <div className="text-xs opacity-80">Get it on</div>
                <div className="text-lg font-heading font-semibold">Google Play</div>
              </div>
            </button>
          </div>
          <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="StarIcon" size={20} className="text-warning fill-warning" />
              <span>4.8/5 Rating</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="UserGroupIcon" size={20} className="text-primary" />
              <span>50,000+ Users</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ShieldCheckIcon" size={20} className="text-success" />
              <span>Secure & Trusted</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 px-4 lg:px-8 bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-6">
          Ready to Start Trading Smarter?
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
          Join 50,000+ traders making profit with AI-driven signals. Download now and get your first 7 days of premium free.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button
            onClick={() => onDownloadClick('ios')}
            className="flex items-center justify-center space-x-3 px-8 py-4 bg-foreground text-background rounded-xl hover:scale-105 transition-all duration-200 shadow-lg"
          >
            <Icon name="DevicePhoneMobileIcon" size={24} />
            <div className="text-left">
              <div className="text-xs opacity-80">Download on the</div>
              <div className="text-lg font-heading font-semibold">App Store</div>
            </div>
          </button>
          <button
            onClick={() => onDownloadClick('android')}
            className="flex items-center justify-center space-x-3 px-8 py-4 bg-foreground text-background rounded-xl hover:scale-105 transition-all duration-200 shadow-lg"
          >
            <Icon name="DevicePhoneMobileIcon" size={24} />
            <div className="text-left">
              <div className="text-xs opacity-80">Get it on</div>
              <div className="text-lg font-heading font-semibold">Google Play</div>
            </div>
          </button>
        </div>
        <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="StarIcon" size={20} className="text-warning fill-warning" />
            <span>4.8/5 Rating</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="UserGroupIcon" size={20} className="text-primary" />
            <span>50,000+ Users</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="ShieldCheckIcon" size={20} className="text-success" />
            <span>Secure & Trusted</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;